const css = `.b5M8VG__button{cursor:default;border:none;border-radius:4px;outline:none;align-items:center;margin:0;padding:0 8px;display:flex}.b5M8VG__button.b5M8VG__hovered{cursor:pointer}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"button":"b5M8VG__button","hovered":"b5M8VG__hovered"};
